import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from '../../storageprovider';
import { InjectHttpClient } from '../InjectHttpClient';
@Injectable()
export class RegionService {
    private _region = new BehaviorSubject<string>("");
    region$ = this._region.asObservable();

    constructor(
        private _inject:InjectHttpClient,
        private _storage:StorageService
    ) { }

    switchRegion(code:string): Observable<any> {
      return this._inject.get('switch-region',{
        region:code
      }).pipe(map(res=>{
             this._storage.SetConfig({
                region:res[0].regionCode
            });
            this._region.next(res[0]);
            return res[0];
      }))
    }
}
